<template>
  <div class="admin">
    <div class="a-filter__header">
      <h2 v-t="'admin.settings'"></h2>
    </div>
    <div class="a-container-form ">
      <div class="a-label a-label--auto">{{$t('form.settings.parameter')}}:</div>
      <div class="a-input a-input--disabled u-width-100">
        <dropdown-new class="a-form-field"
                  :options="listOfSettings"
                  v-model.number="parameter">
        </dropdown-new>
      </div>
    </div>

    <div class="a-container-form ">
      <div class="a-width-100-percent" :class="{'a-input-group--error': $v.value.$error}">
        <textarea class="a-textarea a-width-100-percent" rows="10" placeholder="" v-model="value"></textarea>
      </div>
    </div>

    <div class="personal-data__btn-block" v-if="isChanged">
      <button class="gui-btn gui-btn--red gui-btn--w-140" @click.prevent="onSaveClick" v-t="'buttons.save'"></button>
      <button class="gui-btn gui-btn--white-border gui-btn--w-140" @click.prevent="onCancelClick" v-t="'buttons.cancel'"></button>
    </div>
  </div>
</template>

<script>
  import _ from 'lodash'
  import { required } from '@/validators'

  export default {
    data: () => ({
      settings: undefined,
      parameter: undefined,
      backup: undefined,
      value: undefined
    }),

    computed: {
      listOfSettings() {
        return [{
          name: this.$t('parameters.empty')
        }].concat((this.settings || []).map(e => ({
          id: e.id,
          name: e.name
        })));
      },

      isChanged() {
        return this.value && this.value !== this.backup;
      }
    },

    watch: {
      parameter() {
        this.backup = _.get(_.find(this.settings, { id: this.parameter }), 'value');
        this.value = _.clone(this.backup);
      }
    },

    validations: {
      value: {
        required
      }
    },

    created() {
      this.runBlockerAction(async () => {
        try {
          this.settings = await this.$store.dispatch('fetchSettings');
        }
        catch(e) {
          console.error('unable to fetch list of settings', e);
          this.globalErrorHandler(e);
        }
      });
    },

    methods: {
      onCancelClick() {
        this.value = _.clone(this.backup);
      },

      async onSaveClick() {
        this.runBlockerAction(async () => {
          try {
            this.settings = await this.$store.dispatch('updateSettings', {
              id: this.parameter,
              value: this.value
            });
          }
          catch(e) {
            console.error('unable to update settings', e);
            this.globalErrorHandler(e);
          }
        });
      }
    }
  }
</script>

<style scoped>
</style>
